
import { FileUpload, FileUploadRemoveEvent, FileUploadSelectEvent} from 'primereact/fileupload';
import "./AskForLotsAndExpirationDatePanel.css"
import React, {useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button'
import { ETypeOfNotification, Notification, NotificationRef } from 'medere-ui-framework';
import { InputTextCustom } from 'medere-ui-framework';
import { HttpStatusCode } from 'axios';
import { saveImagesInHC } from '../services/AppointmentService';


function AddImagesToHCPanel(params:{patient:string, professional:string}) {

    const uploaderRef = useRef<FileUpload>(null);
    const [showButton, setShowButton] = useState(false)
    const [description, setDescription] = useState('');
    const [files, setFiles] = useState<File[]>([]);
    const refNotification = useRef<any>(null);

    const chooseOptions = {
        label: 'Select images',
        capture: true,
    };
    useEffect(() => {
        if (files.length == 0)
            setShowButton(false) 
        else 
            setShowButton(true)
    }, [files]);
    
    //Por alguna razón si uso el onUpload no anda el componente bien, entonces tengo que usar el onSelect y me obliga a hacer el for cada vez que se sube un archivo. No encontre manera de resolverlo mejor. 
    const handleFileSelect = (file: FileUploadSelectEvent ) => {
      const newFiles = []
      for (let i = 0; i < file.files.length; i++) {
        if (file.files[i]!=null) {
          const newFile: File =  modifyFileName(file.files[i]);
          newFiles.push(newFile)
        }
      }
      setFiles(newFiles);
    };
    const modifyFileName = (file: File): File => {
      const currentDate = new Date().toISOString().replace(/[:.]/g, '-');
      const fileNameParts = file.name.split('.');
      const fileExtension = fileNameParts.pop();
      const newFileName = `${currentDate}-${fileNameParts.join('.')}.${fileExtension}`;
  
      // Crea un nuevo Blob con el mismo contenido que el archivo original
      const modifiedFile = new File([file], newFileName, { type: file.type });
      return modifiedFile;
    };
    const removeFile = (file: FileUploadRemoveEvent ) => {
        setFiles(prevFiles => prevFiles.filter(prevFile => prevFile !== file.file));
    };

    //metodo que se ejecuta cuando se le da click al botón Subir
    const save = () => {
      saveImagesInHC(files, description, params.patient, params.professional).then(status => {
          if (status != HttpStatusCode.Ok){
            refNotification.current?.notify({title:'Error en la operación', desc: 'Error en la operación', typeOfNotification: ETypeOfNotification.ERROR})
          }
          else{
            refNotification.current?.notify({title:'Operación exitosa', desc: 'La operación a transcurrido con éxito', typeOfNotification: ETypeOfNotification.INFO})
            uploaderRef.current?.clear()
            setFiles([])
            setDescription('')
          }
      })

    };

    const headerTemplate = (options:any) => {
        const { className
            , chooseButton
        } = options;
        
        return (
            <div className={className} style={{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}}> 
                {React.cloneElement(chooseButton,chooseOptions)}
            </div>
        );
    }

  return (
    <div className='p-4 viewContainer'>
      <div>
        <p style={{ marginBottom: '16px', color: 'black' }} className='infoText subTitle'>
          Subir imagen a historia clínica
        </p>
        <div>
          <div className='inputs-container' style={{ display: 'flex', flexDirection: 'column' }}>
            <FileUpload
              ref={uploaderRef}
              name='demo'
              chooseOptions={chooseOptions}
              headerTemplate={headerTemplate}
              accept='.jpg,.png'
              maxFileSize={20000000}
              invalidFileSizeMessageSummary={'Invalid Size'}
              invalidFileSizeMessageDetail={'Invalid Size'}
              onSelect={(file)=>handleFileSelect(file)}
              onRemove={(file)=>removeFile(file)}
              style={{width: "100%"}} 
              multiple
            />
            {<InputTextCustom label = {'Descripción'} inputType = {1} value={description} onChange={(description:any)=>setDescription(description.target.value)}/>}
            {showButton==true && <Button label = "Subir" onClick={save} style = {{marginTop:'10px'} }/>}
            <Notification ref={refNotification}/>
          </div>
        </div>
      </div>
    </div>
  );
}


export default AddImagesToHCPanel
